import {Component, Input, OnInit} from '@angular/core';
import {InspectionReport} from '../../../../shared/models/dvir';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatHeaderCellDef,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { PassFailPipe } from '../../../../shared/formatting/passfail.pipe';

@Component({
  selector: 'app-dvir-inspection',
  templateUrl: './dvir-inspection.component.html',
  styleUrls: ['./dvir-inspection.component.scss'],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRowDef,
    MatRowDef,
    PassFailPipe,
  ],
})
export class DvirInspectionComponent {
  @Input() inspection: InspectionReport;

  displayedColumns: string[] = ['check', 'status', 'explained'];

  constructor() {}
}
